import { CamelCaseKeys } from '@utils/typescript';

export enum PaymentMethods {
  Cheque = 'cheque',
  BankTransfer = 'bank_transfer',
}

export type PaymentInfo = CamelCaseKeys<{
  payment_method: string;
  bank_name: string;
  beneficiary_name: string;
  bank_account: string;
}>;
